import React from 'react';
import { useAuth } from '@clerk/clerk-react';
import './DashboardPlaceholder.css';

const DashboardPlaceholder = () => {
  const { user, isSignedIn } = useAuth();

  return (
    <div className="dashboard-placeholder">
      <div className="placeholder-container">
        <div className="placeholder-header">
          <h1>Welcome to StudioIQ Dashboard</h1>
          <div className="luxury-accent"></div>
        </div>
        
        <div className="placeholder-content">
          <div className="status-section">
            <h2>🚀 Dashboard Coming Soon</h2>
            <p>Your jewelry repair pricing platform is being built with precision and care.</p>
          </div>

          {isSignedIn && (
            <div className="user-section">
              <h3>Welcome back!</h3>
              <div className="user-info">
                <p><strong>Name:</strong> {user?.firstName} {user?.lastName}</p>
                <p><strong>Email:</strong> {user?.emailAddresses[0]?.emailAddress}</p>
                <p><strong>Account Status:</strong> <span className="status-active">Active</span></p>
              </div>
            </div>
          )}

          <div className="features-preview">
            <h3>Coming Features:</h3>
            <ul>
              <li>✨ AI-Powered Jewelry Repair Quotes</li>
              <li>📊 Pricing Analytics Dashboard</li>
              <li>🔧 Repair Management System</li>
              <li>💰 Margin Protection Tools</li>
              <li>📈 Business Intelligence Reports</li>
            </ul>
          </div>

          <div className="placeholder-actions">
            <button className="btn-primary">
              Get Notified When Ready
            </button>
            <button className="btn-secondary">
              Contact Support
            </button>
          </div>
        </div>

        <div className="placeholder-footer">
          <p>© 2025 StudioIQ. Built by industry experts for jewelry professionals.</p>
        </div>
      </div>
    </div>
  );
};

export default DashboardPlaceholder;